<template>
	<li :class="menuItem.class ? menuItem.class : itemClass" class="flex-row flex-between pointer">
		<div class="left-section flex">
			<span v-if="menuItem.icon" :class="`icon primary-icon icon-${menuItem.icon}`"></span>
			<a @click.prevent :href="menuItem.url" class="text fs-14 medium-bold">
				{{ menuItem.name }}
			</a>
		</div>
		<div class="right-section flex-row align-items-start">
			<span v-if="menuItem.secondaryText" class="fs-11 medium-bold">
				{{ menuItem.secondaryText }}
			</span>
			<span class="icon right-icon icon-chevron-right icon-small"></span>
		</div>
	</li>
</template>

<script>
export default {
	name: 'MenuItem',
	props: {
		menuItem: {
			type: Object,
			required: true
		},
		itemClass: {
			type: String,
			default: 'secondary'
		}
	},
};
</script>

<style lang='less' scoped>
@import '~@less/_mixins.less';
li {
	padding: 10px;
	text-align: left;
	width: 100%;
	.right-section {
		font-size: 10px;
		span {
			margin-right: 5px;
			color: darken(#717BA9, 10%);
		}
	}
	.left-section {
		flex: 1;
		.text {
			max-width: 90%;
			color: @DB;
			text-decoration: none;
			line-height: 19px;
		}
	}
	&.primary {
		border-bottom: 2px solid #E5E7F1;
		background: rgb(247, 248, 251);
		.primary-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			color: @LB;
			width: 15px;
			height: 15px;
			font-size: 20px;
			margin-right: 8px;
		}
		.right-icon {
			color: @LB;
		}
	}
	&.secondary {
		padding-left: 15px;
		border-bottom: 2px solid #EAECF4;
		background-color: rgb(229, 231, 241);
		.text {
			font-weight: 500;
		}
		.right-icon {
			color: @DB;
		}
	}
}
</style>